__webpack_require__.p = "https://cdn.new.darjeeling.fr/static/";